{% block sw_seo_url_card_seo_path_edit %}
    <mt-text-field
            :map-inheritance="props"
            :model-value="props.currentValue"
            :copyable="copyable"
            :disabled="isInputDisabled || props.isInherited || isHeadlessSalesChannel || !allowInput"
            :disable-inheritance-toggle="isHeadlessSalesChannel"
            :label="$tc('sw-seo-url.labelSeoPathInfo')"
            :help-text="seoUrlHelptext"
            @update:model-value="props.updateCurrentValue"
    />
{% endblock %}